export const ProductLineHome = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_87_8637)">
      <path
        d="M4.76995 8.10356C3.97359 8.6657 3.5 9.5797 3.5 10.5545L3.5 18.5C3.5 19.6046 4.39543 20.5 5.5 20.5H18.5C19.6046 20.5 20.5 19.6046 20.5 18.5V10.5545C20.5 9.5797 20.0264 8.6657 19.23 8.10356L13.1534 3.81414C12.4619 3.32606 11.5381 3.32606 10.8466 3.81414L4.76995 8.10356Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12 13.5C10.6193 13.5 9.5 14.6193 9.5 16L9.5 20.5H14.5V16C14.5 14.6193 13.3807 13.5 12 13.5V13.5Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_87_8637">
        <rect height="24" width="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
